export default __webpack_public_path__ + "static/media/rengoku2.bce8b918.png";